<template>
  <!-- trigger="click" -->
  <UnSwitcherNew
    :hasOpener="true"
    :hasText="true"
    :hasToggleThreeWay="false"
    tstPrefix="report_sw"
  >
    <template #selected>
      <div
        class="f-center w-100"
        @click="toggleAscDesc"
      >
        <div
          v-html="
            flopSortBy === 'value'
              ? $t(`switchers.${valueTab}`)
              : flopSortBy === 'idx'
                ? flopGroup === 'swv_flops'
                  ? $t(`switchers.flops`)
                  : idxTab === 'data_idx'
                    ? $t(`switchers.cards`)
                    : $t(`switchers.suits`)
                : flopSortBy === 'action'
                  ? actionTab.group_display_name
                    ? $t(`browse.${actionTab.group_display_name}`)
                    : getBetHtml({ a: actionTab, showBetsIn, name: true })
                  : 'error'
          "
        ></div>
        <i
          class="mdi mdi-arrow-up icon_btn text-medium transition_03"
          style="height: 1.125rem; width: 1.125rem"
          :class="{ rotated_180_before: viewProps.flop_sortOrderDesc }"
        ></i>
      </div>
    </template>
    <template #menu_after>
      <GwBtns
        class="gwbtns_vertical_primary"
        style="--gwbtns-padding: 0"
        :options="flopGroup === 'swv_flops' ? flopIdxOptions : turnIdxOptions"
        :value="idxTab"
        idKey="payload"
        tstPrefix="report_sw"
        @click="handleIdxClick"
      >
        <template #default="{ item }">
          <div class="f-center gw_hvr gw_hvr_pointer_coarse_disabled w-100">
            <div
              v-html="
                item.payload === 'data_idx'
                  ? flopGroup === 'swv_flops'
                    ? $t(`switchers.flops`)
                    : $t(`switchers.cards`)
                  : $t(`switchers.${item.payload}`)
              "
            ></div>
            <i
              class="mdi ml-auto gw_hvr_content mdi-arrow-up icon_btn text-medium transition_03"
              style="margin: 0 -0.25rem 0 0; height: 1.125rem; width: 1.125rem"
              :class="{ rotated_180_before: viewProps.flop_sortOrderDesc }"
            ></i>
          </div>
        </template>
      </GwBtns>

      <div class="bt-grey my-1"></div>
      <GwBtns
        class="gwbtns_vertical_primary"
        style="--gwbtns-padding: 0"
        :options="actionOptions"
        :value="actionTab ? actionTab.id : ''"
        idKey="id"
        tstPrefix="report_sw"
        @click="handleActionClick"
      >
        <template #default="{ item }">
          <div class="f-center gw_hvr gw_hvr_pointer_coarse_disabled w-100">
            <div
              v-html="
                item.group_display_name
                  ? $t(`browse.${item.group_display_name}`)
                  : getBetHtml({ a: item, showBetsIn, name: true })
              "
            ></div>
            <i
              class="mdi ml-auto gw_hvr_content mdi-arrow-up icon_btn text-medium transition_03"
              style="margin: 0 -0.25rem 0 0; height: 1.125rem; width: 1.125rem"
              :class="{ rotated_180_before: viewProps.flop_sortOrderDesc }"
            ></i>
          </div>
        </template>
      </GwBtns>

      <div class="bt-grey my-1"></div>

      <GwBtns
        class="gwbtns_vertical_primary"
        style="--gwbtns-padding: 0"
        :options="valueOptions"
        :value="valueTab"
        idKey="payload"
        tstPrefix="report_sw"
        @click="handleValueClick"
      >
        <template #default="{ item }">
          <div class="f-center gw_hvr gw_hvr_pointer_coarse_disabled w-100">
            <div v-html="$t(`switchers.${item.payload}`)"></div>

            <i
              class="mdi ml-auto gw_hvr_content mdi-arrow-up icon_btn text-medium transition_03"
              style="margin: 0 -0.25rem 0 0; height: 1.125rem; width: 1.125rem"
              :class="{ rotated_180_before: viewProps.flop_sortOrderDesc }"
            ></i>
          </div>
        </template>
      </GwBtns>
    </template>
  </UnSwitcherNew>
</template>

<script>
import GwBtns from '@/components/lib/GwBtns'
import format_mix from '@/mixins/format_mix'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import { getGroupedActions } from '@/helpers/grouping'

export default {
  name: 'ReportsFlopSortSwitcher',
  components: {
    UnSwitcherNew,
    GwBtns,
  },
  mixins: [format_mix],
  props: {
    actions: { default: () => [] },
    grouping: String,
    showBetsIn: String,
    viewProps: Object,
    flopGroup: String,
    flopSortBy: String,
  },
  data() {
    this.valueOptions = [
      { payload: 'ip_ev' },
      { payload: 'oop_ev' },
      { payload: 'ip_eq' },
      { payload: 'oop_eq' },
      { payload: 'ip_eqr' },
      { payload: 'oop_eqr' },
    ]
    this.flopIdxOptions = [{ payload: 'data_idx' }]
    this.turnIdxOptions = [
      { payload: 'suits' },
      { payload: 'data_idx' },
      // { payload: 'actions' },
    ]
    return {
      // tab: 'flops',
      // actionTab: {},
    }
  },
  methods: {
    handleIdxClick(_e, item) {
      if (this.idxTab === item.payload) {
        this.toggleAscDesc()
        return
      }
      // console.log(item)
      this.$store.commit('reports_set', { key: 'flop_sortByIdx', value: item.payload })
      this.$store.commit('reports_set', { key: 'flop_sortBy', value: 'idx' })
      this.$store.dispatch('rep_persistSortConf')
    },
    handleValueClick(_e, item) {
      if (this.valueTab === item.payload) {
        this.toggleAscDesc()
        return
      }
      this.$store.commit('reports_set', { key: 'flop_sortByValue', value: item.payload })
      this.$store.commit('reports_set', { key: 'flop_sortBy', value: 'value' })
      this.$store.dispatch('rep_persistSortConf')
    },
    handleActionClick(_e, item) {
      if (this.actionTab.id === item.id) {
        this.toggleAscDesc()
        return
      }
      // console.log(item)
      this.$store.commit('reports_set', { key: 'flop_sortByAction', value: item })
      this.$store.commit('reports_set', { key: 'flop_sortBy', value: 'action' })
      this.$store.dispatch('rep_persistSortConf')
    },
    toggleAscDesc() {
      const ascDesc = this.viewProps.flop_sortOrderDesc ? 'asc' : 'desc'
      this.$store.commit('reports_set', { key: 'flop_sortOrder', value: ascDesc })
      this.$store.dispatch('rep_persistSortConf')
    },
  },
  computed: {
    valueTab() {
      return this.viewProps.flop_sortBy === 'value' ? this.viewProps.flop_sortByValue : ''
    },
    actionTab() {
      return this.viewProps.flop_sortBy === 'action' ? this.viewProps.flop_sortByAction || {} : ''
    },
    idxTab() {
      return this.viewProps.flop_sortBy === 'idx' ? this.viewProps.flop_sortByIdx : ''
    },
    actionOptions() {
      let res = getGroupedActions({
        actions: this.actions || [],
        grouping: this.grouping,
        groupValues: [],
        raisesFirst: false,
      })
      // console.log(res)
      res = res.map(item => {
        item.id = item.id || item.code
        return item
      })
      // console.log(res)
      return res
    },
  },
  watch: {
    actionOptions(val) {
      if (this.tab !== 'none') return
      if (!val.every(item => item.id === this.actionTab.id)) {
        this.handleActionClick(null, val[0])
      }
    },
  },
}
</script>
